// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"203cb583","239":"2be73caa","453":"138719c3","732":"6d813994"}[chunkId] + ".chunk.js";
};